import React from 'react'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import Banner from '../banner'
import MetaData from '../metadata'
import Footer from '../footer'

import styles from './styles'

const PolicyContent = ({ policy, metadata, classes,policies }) => (
  <div>
    <MetaData data={metadata} />
    <Banner uid="policy" title={policy.title} subtitle={policy.subtitle} />
    <div className={classes.contents}>
      <div className={classes.centred}>
        {policy.text.map(item => {
          return (
            <div
              dangerouslySetInnerHTML={{ __html: item && item.html }}
              className={classes.text}
            />
          )
        })}
      </div>
    </div>
    <Footer policies={policies}/>
  </div>
)

export default withStyles(styles)(PolicyContent)



// WEBPACK FOOTER //
// ./src/components/policy/index.js